import { InjectionToken } from '@angular/core';
import { AskAiService } from '../services/ask-ai/ask-ai.service';

export const ASK_AI_SERVICE = new InjectionToken<AskAiService>(
  'ASK_AI_SERVICE'
);
